// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.observations-page .h7 {
  margin-bottom: 40px;
}
.json-schema-form .field input,
.json-schema-form .field textarea,
.json-schema-form .field select,
.json-schema-form .field .rw-datetime-picker,
.json-schema-form .field .help-block,
.json-schema-form .field .warning-block,
.json-schema-form .field .Select {
  max-width: 50%;
}
.json-schema-form .field .warning.box.warning-block {
  padding: 10px;
}
.json-schema-form .language-picker .Select,
.json-schema-form .language-picker .help-block {
  max-width: 100%;
}
.json-schema-form .language-picker .icon-wrapper {
  grid-column-start: auto;
}
.json-schema-form .language-picker .grid-span-8 {
  grid-column-start: 2;
  grid-column-end: 9;
}
.json-schema-form .min-max .form-group {
  margin-bottom: 0px;
}
.json-schema-form .min-max input {
  max-width: none;
  width: 150px;
}
.json-schema-form .min-max .ratio-input {
  justify-content: inherit;
}
.json-schema-form .min-max .help-block {
  max-width: 100%;
}
.json-schema-form .numeric {
  width: 150px;
}
.json-schema-form .numeric input,
.json-schema-form .numeric .help-block {
  max-width: 100%;
}
.json-schema-form.readonly .control-label {
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 1.4px;
  line-height: 20px;
  font-family: 'Work Sans', sans-serif;
  font-weight: 600;
}
.json-schema-form .hidden-title label.control-label {
  display: none;
}
.json-schema-form fieldset legend {
  display: none;
}
.json-schema-form fieldset .form-group {
  margin-bottom: 30px;
}
.json-schema-form fieldset .form-group .language-picker .ht-dropdown {
  margin-bottom: 0;
}
.json-schema-form fieldset .form-group.no-margin-bottom {
  margin-bottom: 0;
}
.json-schema-form fieldset .form-group.margin-top {
  margin-top: 50px;
}
.json-schema-form fieldset .form-group > .remove-top-margin {
  margin-top: -30px;
}
.json-schema-form fieldset .form-group > .comment-field {
  margin-top: -15px;
}
.json-schema-form fieldset .form-group .more-info {
  padding-left: 5px;
}
.json-schema-form fieldset .form-group .more-info .circle {
  padding-right: 3px;
}
.json-schema-form fieldset .form-group .braden-scale-table-row .more-info {
  padding: 0;
}
.json-schema-form .submit-container {
  border-top: 2px solid #f5f8fd;
  padding-top: 40px;
}
.json-schema-form .braden-scale-table-header {
  border-bottom: 2px solid #d8f2ec;
}
.json-schema-form .braden-scale-table-header .h6 {
  margin-bottom: 15px;
}
.json-schema-form .braden-scale-table-row {
  font-family: 'Roboto Condensed', sans-serif;
}
.json-schema-form .braden-scale-table-row table {
  table-layout: fixed;
  margin: 0;
}
.json-schema-form .braden-scale-table-row table th {
  background-color: #d8f2ec;
  border: 0;
  border-bottom: 2px solid #e7f7f3;
  padding: 16px 14px;
}
.json-schema-form .braden-scale-table-row table td {
  border: 0;
  border-bottom: 2px solid #d8f2ec;
  border-right: 2px solid #d8f2ec;
  background-color: #ffffff;
  padding: 16px 14px;
}
.json-schema-form .braden-scale-table-row table td.selected {
  background-color: #f4f7f6;
}
.json-schema-form .braden-scale-table-row .medium {
  font-weight: 700;
}
.json-schema-form .field-array .pull-right .icon,
.json-schema-form .field-object .pull-right .icon {
  margin-left: 15px;
}
.json-schema-form .field-array > ul {
  margin-bottom: 30px;
}
.json-schema-form .field-array > ul > li {
  padding: 20px;
  background-color: #d8f2ec;
}
.json-schema-form .field-array > ul > li > .form-group {
  margin-bottom: 0;
}
.json-schema-form .field-array .array-item {
  width: 50%;
  margin-bottom: 15px;
}
.json-schema-form .field-array .array-item:last-child {
  margin-bottom: 0;
}
.json-schema-form .field-array .field-object {
  overflow: hidden;
}
.json-schema-form .field-array .field-object p {
  margin: 0;
}
.json-schema-form .field-array .field-object .pull-left {
  clear: both;
}
.field-object .header p {
  font-weight: bold;
}
.modal .json-schema-form .field input,
.modal .json-schema-form .field textarea,
.modal .json-schema-form .field select,
.modal .json-schema-form .field .rw-datetime-picker,
.modal .json-schema-form .field .help-block,
.modal .json-schema-form .field .warning-block,
.modal .json-schema-form .field .Select {
  max-width: 100%;
}
`, "",{"version":3,"sources":["webpack://./../styleguide/src/components/JsonSchemaForm/main.less"],"names":[],"mappings":"AAEA;EAEI,mBAAA;AAFJ;AAMA;;;;;;;EASM,cAAA;AANN;AAHA;EAaM,aAAA;AAPN;AANA;;EAoBM,eAAA;AAVN;AAVA;EAwBM,uBAAA;AAXN;AAbA;EA4BM,oBAAA;EACA,kBAAA;AAZN;AAjBA;EAmCM,kBAAA;AAfN;AApBA;EAsCM,eAAA;EACA,YAAA;AAfN;AAxBA;EA0CM,wBAAA;AAfN;AA3BA;EA6CM,eAAA;AAfN;AA9BA;EAkDI,YAAA;AAjBJ;AAjCA;;EAsDM,eAAA;AAjBN;AAqBE;EAEI,yBAAA;EACA,eAAA;EACA,qBAAA;EACA,iBAAA;EACA,oCAAA;EACA,gBAAA;AApBN;AA7CA;EAsEI,aAAA;AAtBJ;AAhDA;EA2EM,aAAA;AAxBN;AAnDA;EA+EM,mBAAA;AAzBN;AAtDA;EAkFQ,gBAAA;AAzBR;AA4BM;EACE,gBAAA;AA1BR;AA6BM;EACE,gBAAA;AA3BR;AA/DA;EA8FQ,iBAAA;AA5BR;AAlEA;EAkGQ,iBAAA;AA7BR;AArEA;EAsGQ,iBAAA;AA9BR;AAxEA;EAyGU,kBAAA;AA9BV;AA3EA;EA+GU,UAAA;AAjCV;AA9EA;EAsHI,6BAAA;EACA,iBAAA;AArCJ;AAlFA;EA2HI,gCAAA;AAtCJ;AArFA;EA8HM,mBAAA;AAtCN;AAxFA;EAmII,2CAAA;AAxCJ;AA3FA;EAsIM,mBAAA;EACA,SAAA;AAxCN;AA/FA;EA0IQ,yBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AAxCR;AArGA;EAiJQ,SAAA;EACA,gCAAA;EACA,+BAAA;EACA,yBAAA;EACA,kBAAA;AAzCR;AA2CQ;EACE,yBAAA;AAzCV;AA/GA;EA+JM,gBAAA;AA7CN;AAlHA;;EAsKM,iBAAA;AAhDN;AAtHA;EA4KM,mBAAA;AAnDN;AAzHA;EA+KQ,aAAA;EACA,yBAAA;AAnDR;AA7HA;EAmLU,gBAAA;AAnDV;AAhIA;EAyLM,UAAA;EACA,mBAAA;AAtDN;AAwDM;EACE,gBAAA;AAtDR;AAvIA;EAkMM,gBAAA;AAxDN;AA1IA;EAqMQ,SAAA;AAxDR;AA7IA;EAyMQ,WAAA;AAzDR;AA+DA;EAEI,iBAAA;AA9DJ;AAkEA;;;;;;;EAUQ,eAAA;AAnER","sourcesContent":["@import '~styleguide/src/styles/variables.less';\n\n.observations-page {\n  .h7 {\n    margin-bottom: 40px;\n  }\n}\n\n.json-schema-form {\n  .field {\n    input,\n    textarea,\n    select,\n    .rw-datetime-picker,\n    .help-block,\n    .warning-block,\n    .Select {\n      max-width: 50%;\n    }\n\n    .warning.box.warning-block {\n      padding: 10px;\n    }\n  }\n\n  .language-picker {\n    .Select,\n    .help-block {\n      max-width: 100%;\n    }\n\n    .icon-wrapper {\n      grid-column-start: auto;\n    }\n\n    .grid-span-8 {\n      grid-column-start: 2;\n      grid-column-end: 9;\n    }\n  }\n\n  .min-max {\n    .form-group {\n      margin-bottom: 0px;\n    }\n    input {\n      max-width: none;\n      width: 150px;\n    }\n    .ratio-input {\n      justify-content: inherit;\n    }\n    .help-block {\n      max-width: 100%;\n    }\n  }\n\n  .numeric {\n    width: 150px;\n\n    input,\n    .help-block {\n      max-width: 100%;\n    }\n  }\n\n  &.readonly {\n    .control-label {\n      text-transform: uppercase;\n      font-size: @font-size-h6;\n      letter-spacing: @letter-spacing-h6;\n      line-height: @p-line-height;\n      font-family: @font-family-work-sans;\n      font-weight: 600;\n    }\n  }\n\n  .hidden-title label.control-label {\n    display: none;\n  }\n\n  fieldset {\n    legend {\n      display: none;\n    }\n\n    .form-group {\n      margin-bottom: 30px;\n\n      .language-picker .ht-dropdown {\n        margin-bottom: 0;\n      }\n\n      &.no-margin-bottom {\n        margin-bottom: 0;\n      }\n\n      &.margin-top {\n        margin-top: 50px;\n      }\n\n      > .remove-top-margin {\n        margin-top: -30px;\n      }\n\n      > .comment-field {\n        margin-top: -15px;\n      }\n\n      .more-info {\n        padding-left: 5px;\n\n        .circle {\n          padding-right: 3px;\n        }\n      }\n\n      .braden-scale-table-row {\n        .more-info {\n          padding: 0;\n        }\n      }\n    }\n  }\n\n  .submit-container {\n    border-top: 2px solid #f5f8fd;\n    padding-top: 40px;\n  }\n\n  .braden-scale-table-header {\n    border-bottom: 2px solid @lightMint;\n\n    .h6 {\n      margin-bottom: 15px;\n    }\n  }\n\n  .braden-scale-table-row {\n    font-family: @font-family-roboto-condensed;\n\n    table {\n      table-layout: fixed;\n      margin: 0;\n\n      th {\n        background-color: @lightMint;\n        border: 0;\n        border-bottom: 2px solid @lightMint-lightened;\n        padding: 16px 14px;\n      }\n\n      td {\n        border: 0;\n        border-bottom: 2px solid @lightMint;\n        border-right: 2px solid @lightMint;\n        background-color: @white;\n        padding: 16px 14px;\n\n        &.selected {\n          background-color: @bkgdBlue;\n        }\n      }\n    }\n\n    .medium {\n      // TODO: check with designers on standardizing the font weight\n      font-weight: 700;\n    }\n  }\n\n  .field-array,\n  .field-object {\n    .pull-right .icon {\n      margin-left: 15px;\n    }\n  }\n\n  .field-array {\n    > ul {\n      margin-bottom: 30px;\n\n      > li {\n        padding: 20px;\n        background-color: @lightMint;\n\n        > .form-group {\n          margin-bottom: 0;\n        }\n      }\n    }\n\n    .array-item {\n      width: 50%;\n      margin-bottom: 15px;\n\n      &:last-child {\n        margin-bottom: 0;\n      }\n    }\n\n    .field-object {\n      overflow: hidden;\n\n      p {\n        margin: 0;\n      }\n\n      .pull-left {\n        clear: both;\n      }\n    }\n  }\n}\n\n.field-object {\n  .header p {\n    font-weight: bold;\n  }\n}\n\n.modal {\n  .json-schema-form {\n    .field {\n      input,\n      textarea,\n      select,\n      .rw-datetime-picker,\n      .help-block,\n      .warning-block,\n      .Select {\n        max-width: 100%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
